import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSecurityAuthRoleList } from "../../../../store/security/action";
import SecurityLists from "../../../../Components/Page/Settings/Company/security";

export default function SecurityRoles({ page }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getSecurityAuthRoleList());
  }, []);
  const { securityAuthRoleListAPI } = useSelector((state) => ({
    securityAuthRoleListAPI:
      state.Security.securityAuthRoleList?.securityauthrole_list,
  }));

  return (
    <>
      <SecurityLists
        data={securityAuthRoleListAPI}
        page={page}
        reportName={"securityRoleList"}
      />
    </>
  );
}
